export default __webpack_public_path__ + "static/media/G6ESS_150.4de5ea6d.jpg";